var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashCarEntry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2895_1492)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13V20.375C2 20.9937 2.5 21.5 3.11111 21.5H4.22222C4.83333 21.5 5.33333 20.9937 5.33333 20.375V19.25H18.6667V20.375C18.6667 20.9937 19.1667 21.5 19.7778 21.5H20.8889C21.5 21.5 22 20.9937 22 20.375V11.375L19.6889 4.63625C19.4667 3.9725 18.8444 3.5 18.1111 3.5H9V5.75H17.7111L18.8667 9.125H9V13C9 13.572 8.8628 14.1119 8.61953 14.5886C8.41848 14.9826 8.15317 15.3538 7.7066 15.7169C7.10451 16.2065 6.33652 16.5 5.5 16.5C3.567 16.5 2 14.933 2 13ZM15.3333 14.1875C15.3333 15.1213 16.0778 15.875 17 15.875C17.9222 15.875 18.6667 15.1213 18.6667 14.1875C18.6667 13.2537 17.9222 12.5 17 12.5C16.0778 12.5 15.3333 13.2537 15.3333 14.1875Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 1.5L6 10.6L8 10.6L5 15.5L2 10.6L4 10.6L4 1.5L6 1.5Z",
    fill: "#42BA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2895_1492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashCarEntry);
export default __webpack_public_path__ + "static/media/dash-car-entry.8fd78f82673dc09b0cf506909054e8aa.svg";
export { ForwardRef as ReactComponent };